import type { ResonancePhase } from '../game/simulation/dropBag';

export const PHASE_TRANSITION_ASSETS = [
  'phase-transition-2', 'phase-transition-3', 'phase-transition-4', 'phase-transition-5',
] as const;

export type PhaseTransitionKey = (typeof PHASE_TRANSITION_ASSETS)[number];

export function phaseTransitionKey(phase: ResonancePhase): PhaseTransitionKey | null {
  return phase === 1 ? null : `phase-transition-${phase}`;
}
